import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Pagination,
  PaginationItem,
  Radio,
  RadioGroup,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { IWaitForSettlement } from "./IWaitForSettlement";
import { createStyles, makeStyles } from "@material-ui/core";
import {
  ApiResultModel,
  ColumnModel,
  PageInfoModel,
} from "../../../models/common.model";
import {
  Filter,
  getGroupedSalesResponse,
  getSalesByCustomerSearchRequest,
  IgroupedByBranches,
} from "../../../models/supplier.model";
import { getTokenClaims } from "../../../services/auth.service";
import ToolsCmp from "../../loan/toolsCmp";
import {
  FilterFinder,
  GetLoansRequest,
  PaginationInfo,
} from "../../../models/loan.model";
import { useHistory } from "react-router-dom";
import { useMutation, useQueryClient } from "react-query";
import {
  SALE_ITEM,
  TABLE_FILTER,
  TABLE_FILTER_REGISTER,
} from "../../../config/cacheKey";
import {
  IGetBranchesRequest,
  IGetEnumsRequest,
  IResponse,
} from "../../../models/dropdown.model";
import {
  GetBranches,
  GetEnums,
  GetIBans,
} from "../../../services/dropdown.service";
import { Formik } from "formik";
import { convertToLocalDateTime } from "../../../utility/dateUtility";
import MaterialTextFieldComponent from "../../../components/textField/MaterialTextFieldCmp";
import MultiSelectChip from "../../../components/dropdown/MultiSelectChip";
import DatePickerComponents from "../../../components/datePicker/DatePickerComponents";
import ChipCmp from "../../../components/chip/chipCmp";
import {
  GetGroupedSales,
  GetGroupedSalesByBranchExcel,
  GetGroupedSalesByIbanExcel,
} from "../../../services/supplier.service";
import { ISaleItemRequest } from "../../../models/sale.model";

const branchColumns: readonly ColumnModel[] = [
  { id: "supplierName", label: "نام پذیرنده" },
  { id: "branchName", label: "نام شعبه" },
  {
    id: "totalFactorAmount",
    label: "مبلغ فاکتور(ریال)",
    hasFormat: true,
    format: (value: number) => {
      return value?.toLocaleString("fa");
    },
  },
  {
    id: "totalSettlementAmount",
    label: "مبلغ تسویه (ریال)",
    hasFormat: true,
    format: (value: number) => {
      return value?.toLocaleString("fa");
    },
  },
];
const ibanColumns: readonly ColumnModel[] = [
  { id: "ibanNumber", label: "شماره شبا " },
  { id: "ibanOwner", label: "نام صاحب حساب " },
  {
    id: "totalFactorAmount",
    label: "مبلغ فاکتور(ریال)",
    hasFormat: true,
    format: (value: number) => {
      return value?.toLocaleString("fa");
    },
  },
  {
    id: "totalSettlementAmount",
    label: "مبلغ تسویه (ریال)",
    hasFormat: true,
    format: (value: number) => {
      return value?.toLocaleString("fa");
    },
  },
];
let muiSelected: any;
const useStyles = makeStyles((theme) =>
  createStyles({
    select: {
      "&.Mui-selected": {
        backgroundColor: muiSelected,
      },
    },
  })
);

let columns: readonly ColumnModel[];

export default function WaitForSettlementDetail({
  groupedByBranches,
  groupedByIban,
  getPageInfo,
}: IWaitForSettlement) {
  const canRegisterLoan = String(getTokenClaims()?.canRegisterLoan);
  const [selectedIban, setSelectedIban] = useState<string[]>([]);
  const classes = useStyles();
  const [submitFlag, setSubmitFlag] = React.useState<boolean>(true);
  // const [radioId, setRadioId] = React.useState();
  const [data, setData] = React.useState<any[]>([]);
  const [branch, setBranch] = useState<boolean>(true);
  const queryClient = useQueryClient();
  const [selectedRow, setSelectedRow] = useState(undefined);
  const history = useHistory<{
    from: string;
    id: number;
    pageNumber: number;
    clickOnBack: boolean;
    saleKey: string;
    branchId: number;
    ibans: string;
  }>();
  const [pageInfo, setPageInfo] = React.useState<PageInfoModel>(
    (): PageInfoModel => {
      let pageInfoModel = new PageInfoModel();
      pageInfoModel.pageNumber = -1;
      pageInfoModel.pageSize = 10;
      pageInfoModel.total = 0;

      return pageInfoModel;
    }
  );

  const [currentPaginationInfo, setCurrentPaginationInfo] = React.useState(
    (): PaginationInfo => {
      let paginationInfo = new PaginationInfo();
      paginationInfo.pageNumber =
        history.location.state != undefined
          ? history.location.state.pageNumber
          : 1;
      return paginationInfo;
    }
  );

  const generateFilter = (
    filterData: Filter
  ): getSalesByCustomerSearchRequest => {
    let request = new getSalesByCustomerSearchRequest();
    request.paginationInfo = currentPaginationInfo;
    request.filter = filterData;
    return request;
  };

  const fillData = (filterData: Filter) => {
    let filter = generateFilter(filterData);
    GetGroupedSalesMutate(filter);
    setValueFilterData(filter?.filter);
  };
  const changePageNumber = (newPageNumber: number) => {
    const tabelFilter = queryClient.getQueryData<Filter>(TABLE_FILTER);
    fillData(tabelFilter!);
    currentPaginationInfo.pageNumber = newPageNumber;
    setCurrentPaginationInfo(currentPaginationInfo);
  };
  const previousPage =
    history.location.state !== undefined ? history.location.state.from : null;
  // const handleSelectRow = (rowIndex: any) => {
  //   const cachPageNumber = queryClient.getQueryData(
  //     TABLE_FILTER_REGISTER
  //   ) as FilterFinder;
  //   const filter = new FilterFinder();
  //   filter.rowNumber = rowIndex;
  //   setSelectedRow(rowIndex);
  //   queryClient.setQueryData(TABLE_FILTER_REGISTER, filter);
  // };

  const { mutateAsync: GetGroupedSalesMutate } = useMutation(GetGroupedSales, {
    onSuccess: (data: ApiResultModel<getGroupedSalesResponse>) => {
      const pageInfo = new PageInfoModel();
      pageInfo.pageNumber = data.data.groupedByBranches.pageNumber;
      pageInfo.pageSize = data.data.groupedByBranches.pageSize;
      pageInfo.total = data.data.groupedByBranches.totalCount;
      setPageInfo(pageInfo);
      if (data.data.groupedByBranches?.result.length! > 0) {
        setData(groupedByBranches!.result);
        columns = branchColumns;
        setBranch(true);
      } else if (data.data.groupedByIban?.result.length! > 0) {
        setData(groupedByIban!.result);
        columns = ibanColumns;
        setBranch(false);
      } else {
        setData([]);
      }
    },
  });

  const { mutateAsync: GetGroupedSalesByBranchExcelMutate } = useMutation(
    GetGroupedSalesByBranchExcel,
    {
      onSuccess: (result) => {},
      onError: (e) => {},
    }
  );
  const handleSelectRow = (rowIndex: any) => {
    const cachPageNumber = queryClient.getQueryData(
      TABLE_FILTER_REGISTER
    ) as FilterFinder;
    const filter = new FilterFinder();
    filter.rowNumber = rowIndex;
    setSelectedRow(rowIndex);
    queryClient.setQueryData(TABLE_FILTER_REGISTER, filter);
  };

  const handleChangePagination = (event: any, value: any) => {
    changePageNumber(value);
    handleSelectRow(undefined);
  };
  const [valueCustomerNationalCode, setValueCustomerNationalCode] = useState<
    string
  >();
  const [valueCustomerName, setValueCustomerName] = useState<string>();
  const [valueCustomerMobileNumber, setValueCustomerMobileNumber] = useState<
    string
  >();
  const [valueBranchIds, setValueBranchIds] = useState<any[]>([]);
  const [valueIbans, setValueIbans] = useState<any[]>([]);
  const [valueSaleStatuses, setValueSaleStatuses] = useState<string[]>([]);
  const [valueSettlementDate, setValueSettlementDate] = useState<string>();
  const [valueSaleDate, setValueSaleDate] = useState<string>();
  const [settlementDate, setSettlementDate] = useState<
    Date[] | null | undefined
  >(null);
  const [branchOption, setBranchOption] = React.useState<IResponse[]>([]);
  const [ibansOption, setIbansOption] = React.useState<IResponse[]>([]);
  const [saleStatusesOption, setSaleStatusesOption] = React.useState<
    IResponse[]
  >([]);
  const [valueFilterData, setValueFilterData] = React.useState<Filter>();

  const [saleDate, setSaleDate] = useState<Date[] | null | undefined>(null);
  const { mutateAsync: GetBranchesMutate } = useMutation(GetBranches, {
    onSuccess: (data: IResponse[]) => {
      setBranchOption(data);
    },
  });
  const { mutateAsync: GetIbansMutate } = useMutation(GetIBans, {
    onSuccess: (data: IResponse[]) => {
      setIbansOption(data);
    },
  });
  const { mutateAsync: GetEnumsMutate } = useMutation(GetEnums, {
    onSuccess: (data: IResponse[]) => {
      setSaleStatusesOption(data);
    },
  });

  const setChildValueCustomerName = (childValues: any) => {
    const selectedItem = "";
    setValueCustomerName(selectedItem);
    const tabelFilter = queryClient.getQueryData<Filter>(TABLE_FILTER);
    if (tabelFilter != undefined) tabelFilter!.customerName = undefined;
    fillData(tabelFilter!);
  };
  const setChildValueCustomerNationalCode = (childValues: any) => {
    const selectedItem = "";
    setValueCustomerNationalCode(selectedItem);
    const tabelFilter = queryClient.getQueryData<Filter>(TABLE_FILTER);
    if (tabelFilter != undefined) tabelFilter!.customerNationalCode = undefined;
    fillData(tabelFilter!);
  };

  const setChildValueBranchIds = (childValues: any) => {
    const selectedItem = valueBranchIds.filter(
      (item: any) => item !== childValues
    );
    setValueBranchIds(selectedItem);
    const tabelFilter = queryClient.getQueryData<Filter>(TABLE_FILTER);
    if (tabelFilter !== undefined && tabelFilter !== null) {
      tabelFilter.branchIds = tabelFilter!.branchIds
        ?.filter((item: any) => item !== childValues)
        .map((items: any) => {
          return items;
        });
    }
    fillData(tabelFilter!);
  };
  const setChildValueIbans = (childValues: any) => {
    const selectedItem = valueIbans.filter((item: any) => item !== childValues);
    setValueIbans(selectedItem);
    const tabelFilter = queryClient.getQueryData<Filter>(TABLE_FILTER);
    if (tabelFilter !== undefined && tabelFilter !== null) {
      tabelFilter.ibans = tabelFilter!.ibans
        ?.filter((item: any) => item !== childValues)
        .map((items: any) => {
          return items;
        });
    }
    fillData(tabelFilter!);
  };
  const setChildValueSaleStatuses = (childValues: any) => {
    const selectedItem = valueSaleStatuses.filter(
      (item: any) => item !== childValues
    );
    setValueSaleStatuses(selectedItem);
    const tabelFilter = queryClient.getQueryData<Filter>(TABLE_FILTER);
    if (tabelFilter !== undefined && tabelFilter !== null) {
      tabelFilter.saleStatuses = tabelFilter!.saleStatuses
        ?.filter((item: any) => item !== childValues)
        .map((items: any) => {
          return items;
        });
    }
    fillData(tabelFilter!);
  };
  const setChildValueCustomerMobileNumber = (childValues: any) => {
    const selectedItem = "";
    setValueCustomerMobileNumber(selectedItem);
    const tabelFilter = queryClient.getQueryData<Filter>(TABLE_FILTER);
    if (tabelFilter != undefined) tabelFilter!.customerMobileNumber = undefined;
    fillData(tabelFilter!);
  };
  const setChildValueSettlementDate = (childValues: any) => {
    const selectedItem = "";
    setValueSettlementDate(selectedItem);
    setSettlementDate(undefined);
    const tabelFilter = queryClient.getQueryData<Filter>(TABLE_FILTER);
    if (tabelFilter != undefined) {
      tabelFilter!.settlementDateFrom = undefined;
      tabelFilter!.settlementDateTo = undefined;
      // tabelFilter!.requestDatePersian = "";
      // tabelFilter!.requestDateArray = [];
      tabelFilter!.settlementDate = undefined;
    }

    fillData(tabelFilter!);
  };
  const setChildValueSaleDate = (childValues: any) => {
    const selectedItem = "";
    setValueSaleDate(selectedItem);
    setSaleDate(undefined);
    const tabelFilter = queryClient.getQueryData<Filter>(TABLE_FILTER);
    if (tabelFilter != undefined) {
      tabelFilter!.saleDateFrom = undefined;
      tabelFilter!.saleDateTo = undefined;
      // tabelFilter!.requestDatePersian = "";
      // tabelFilter!.requestDateArray = [];
      tabelFilter!.saleDate = undefined;
    }

    fillData(tabelFilter!);
  };

  useEffect(() => {
    let filterData;
    if (
      previousPage !== null ||
      (history.action === "REPLACE" &&
        history.location.state !== undefined &&
        history.location.state.clickOnBack)
    ) {
      filterData = queryClient.getQueryData<Filter>(TABLE_FILTER);
      if (filterData !== undefined && filterData !== null) {
        setValueCustomerName(filterData!.customerName!);
        setValueCustomerNationalCode(filterData!.customerName!);
        setValueCustomerMobileNumber(filterData!.customerMobileNumber!);
        setValueBranchIds(filterData!.branchIds!);
        setValueIbans(filterData!.ibans!);
        setValueSaleStatuses(filterData?.saleStatuses!);
        setValueFilterData(filterData);
        setValueSaleDate("");
      }
    } else {
      filterData = new Filter();
      filterData.customerName = "";
      filterData.customerNationalCode = "";
      filterData.customerMobileNumber = "";
      filterData.branchIds = [];
      filterData.ibans = [];
      // filterData.requestDatePersian = "";
      queryClient.setQueryData(TABLE_FILTER, null);
      setValueFilterData(filterData);
    }
    fillData(filterData!);
    const getBranches = {} as IGetBranchesRequest;
    // getBranches.title = "";
    GetBranchesMutate(getBranches);
    GetIbansMutate(getBranches);
    const enums = {} as IGetEnumsRequest;
    enums.enumNames = ["SaleStatus"];
    GetEnumsMutate(enums);

    setPageInfo(getPageInfo!);
    if (groupedByBranches?.result.length! > 0) {
      setData(groupedByBranches!.result);
      columns = branchColumns;
      setBranch(true);
    } else if (groupedByIban?.result.length! > 0) {
      setData(groupedByIban!.result);
      columns = ibanColumns;
      setBranch(false);
    }
  }, []);
  const handleChange = (event: any) => {
    // setRadioId(event.target.value);
    if (event.target.value === "branch") {
      setData(groupedByBranches!.result);
      columns = branchColumns;
      setBranch(true);
    } else {
      setData(groupedByIban!.result);
      columns = ibanColumns;
      setBranch(false);
    }
    // setId(event.target.value);
    // queryClient.setQueryData(LOAN_ID, event.target.value);
    // props.setLoanId(event.target.value);
  };
  const previusIcon = () => {
    return (
      <img
        style={{ height: "12px", width: "10px" }}
        src='images/Previous.png'
      />
    );
  };
  const nextIcon = () => {
    return (
      <img style={{ height: "12px", width: "10px" }} src='images/Next.png' />
    );
  };
  function changeValueCustomerName(e: any) {
    setValueCustomerName(e.currentTarget.value);
  }
  function changeValueCustomerNationalCode(e: any) {
    setValueCustomerNationalCode(e.currentTarget.value);
  }

  function changeValueBranchIds(e: any) {
    setValueBranchIds(e);
  }
  function changeValueIbans(e: number[]) {
    const selectedIbanTitles = e
      .map((ibanId) => {
        const iban = ibansOption.find((item) => item.id === ibanId);
        return iban ? iban.title : "";
      })
      .filter((title) => title !== "");
    setSelectedIban(selectedIbanTitles);
    setValueIbans(e);
  }
  function changeValueCustomerMobileNumber(e: any) {
    setValueCustomerMobileNumber(e.currentTarget.value);
  }
  function changeValueSaleStatuses(e: any) {
    setValueSaleStatuses(e);
  }

  function changeValueSettlementDate(e: any) {
    setSettlementDate(e);
    setValueSettlementDate(e.toString().replace(/,/g, " - "));
  }
  function changeValueSaleDate(e: any) {
    setSaleDate(e);
    setValueSaleDate(e.toString().replace(/,/g, " - "));
  }
  function deleteChip() {
    setValueBranchIds([]);
    setValueIbans([]);
    setValueSaleStatuses([]);
    setValueCustomerName("");
    setValueCustomerMobileNumber("");
    setValueCustomerNationalCode("");
    setValueSettlementDate("");
    setValueSaleDate("");
    setSaleDate([]);
    setSettlementDate([]);
    queryClient.setQueryData(TABLE_FILTER, null);
    fillData(queryClient.getQueryData(TABLE_FILTER)!);
    currentPaginationInfo.pageNumber = 1;
    setCurrentPaginationInfo(currentPaginationInfo);
  }
  const filter = new Filter();
  filter.branchIds = [];
  filter.ibans = [];
  filter.saleStatuses = [];

  const [isShow, setIsShow] = useState(true);
  let handelFilter = () => {
    setIsShow(!isShow);
  };

  let exportExcel = () => {
    branch === true
      ? GetGroupedSalesByBranchExcelMutate(
          valueFilterData ? valueFilterData! : new Filter()
        )
      : GetGroupedSalesByIbanExcel(
          valueFilterData ? valueFilterData! : new Filter()
        );
  };
  const handelDetail = (
    saleKey: string,
    ibanNumber: string,
    branchId: number,
    ibanId: number,
    rowIndex: number
  ) => {
    handleSelectRow(rowIndex);
    history.push({
      pathname: "/financial/WaitForSettlementByCustomer",
    });
    const request = {} as ISaleItemRequest;
    request.saleKey = saleKey!;
    request.branchId = branchId!;
    request.ibans = ibanNumber!;
    request.ibanId = ibanId!;
    localStorage.setItem(SALE_ITEM, JSON.stringify(request));
  };
  return (
    <>
      <Grid container xs={12}>
        <Grid item xs={6}>
          <Tooltip title='فیلتر' arrow>
            <img
              onClick={handelFilter}
              style={{ width: "24px", height: "24px", marginBottom: ".5vh" }}
              src='images/filter.png'
            />
          </Tooltip>
          <span style={{ margin: "2vh", color: "#CFD8DC" }}>|</span>
          <Tooltip title='خروجی اکسل' arrow>
            <img
              onClick={exportExcel}
              className='cursorPointer'
              style={{ width: "24px", height: "24px", marginBottom: ".5vh" }}
              src='images/ExportXLS.svg'
            />
          </Tooltip>
        </Grid>
        <Grid item xs={6} style={{ textAlign: "end", paddingLeft: "2vh" }}>
          <FormControl component='fieldset'>
            <RadioGroup
              row
              aria-label='gender'
              defaultValue={"branch"}
              onChange={handleChange}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  if (submitFlag) {
                    setSubmitFlag(false);
                    // props.handleNext();
                  }
                }
              }}
              style={{
                alignItems: "center",
                color: "#757575",
                fontSize: "16px",
              }}
            >
              <FormLabel
                id='demo-controlled-radio-buttons-group'
                className='fontMedium'
              >
                به تفکیک:
              </FormLabel>
              <FormControlLabel
                value='branch'
                control={<Radio />}
                label='شعبه'
              />
              <FormControlLabel
                value='iban'
                control={<Radio />}
                label='شماره شبا'
              />
            </RadioGroup>
          </FormControl>
        </Grid>
      </Grid>

      {isShow ? (
        <Box sx={{ flexGrow: 1 }}>
          <Formik
            initialValues={filter}
            onSubmit={(values: any) => {
              if (
                settlementDate != null &&
                (settlementDate[0] != undefined ||
                  settlementDate[1] != undefined)
              ) {
                values.settlementDateFrom = convertToLocalDateTime(
                  Number(settlementDate[0])
                );
                if (settlementDate.length > 1) {
                  values.settlementDateTo = convertToLocalDateTime(
                    Number(settlementDate[1])
                  );
                } else {
                  values.settlementDateTo = convertToLocalDateTime(
                    Number(settlementDate[0])
                  );
                }
              } else {
                values.settlementDateFrom = undefined;
                values.settlementDateTo = undefined;
                values.settlementDate = undefined;
              }
              if (
                saleDate != null &&
                (saleDate[0] != undefined || saleDate[1] != undefined)
              ) {
                values.saleDateFrom = convertToLocalDateTime(
                  Number(saleDate[0])
                );
                if (saleDate.length > 1) {
                  values.saleDateTo = convertToLocalDateTime(
                    Number(saleDate[1])
                  );
                } else {
                  values.saleDateTo = convertToLocalDateTime(
                    Number(saleDate[0])
                  );
                }
              } else {
                values.saleDateFrom = undefined;
                values.saleDateTo = undefined;
                values.saleDate = undefined;
              }
              // values.requestDatePersian = valueRequestDate;
              // values.requestDateArray = requestDate;

              queryClient.setQueryData(TABLE_FILTER, values);
              values.customerName = valueCustomerName;
              values.customerNationalCode = valueCustomerNationalCode;
              values.customerMobileNumber = valueCustomerMobileNumber;
              values.branchIds = valueBranchIds;
              values.ibans = selectedIban;
              values.saleStatuses = valueSaleStatuses;
              values.settlementDate = valueSettlementDate;
              values.saleDate = valueSaleDate;
              fillData(values);
              currentPaginationInfo.pageNumber = 1;
              setCurrentPaginationInfo(currentPaginationInfo);
              // changePageNumber(1);
            }}
          >
            {({ handleSubmit, handleChange, values }) => (
              <form onSubmit={handleSubmit}>
                <div className='row'>
                  <div
                    className='col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12'
                    style={{ paddingTop: "30px" }}
                  >
                    <MaterialTextFieldComponent
                      className='shadowTextField'
                      helperText={""}
                      placeHolder={"متقاضی"}
                      label={"متقاضی "}
                      required={false}
                      value={valueCustomerName}
                      onChange={changeValueCustomerName}
                      name='customerName'
                      id='customerName'
                    />
                  </div>
                  <div
                    className='col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12'
                    style={{ paddingTop: "30px" }}
                  >
                    <MaterialTextFieldComponent
                      className='shadowTextField'
                      helperText={""}
                      placeHolder={"کد ملی"}
                      label={"کد ملی "}
                      required={false}
                      value={valueCustomerNationalCode}
                      onChange={changeValueCustomerNationalCode}
                      name='customerNationalCode'
                      id='customerNationalCode'
                      type='number'
                      inputProps={{ maxLength: 10 }}
                    />
                  </div>
                  <div
                    className='col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12'
                    style={{ paddingTop: "30px" }}
                  >
                    <MaterialTextFieldComponent
                      className='shadowTextField'
                      helperText={""}
                      placeHolder={"َشماره همراه"}
                      label={"َشماره همراه "}
                      required={false}
                      value={valueCustomerMobileNumber}
                      onChange={changeValueCustomerMobileNumber}
                      name='customerMobileNumber'
                      id='customerMobileNumber'
                      type='tel'
                      inputProps={{ maxLength: 11 }}
                    />
                  </div>
                  <div
                    className='col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12'
                    style={{ paddingTop: "30px" }}
                  >
                    <MultiSelectChip
                      label={"نام شعبه "}
                      value={valueBranchIds}
                      onChange={changeValueBranchIds}
                      changeMultiSelect={changeValueBranchIds}
                      name='customerBranchIds'
                      id='customerBranchIds'
                      options={branchOption}
                    />
                  </div>
                  <div
                    className='col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12'
                    style={{ paddingTop: "30px" }}
                  >
                    <MultiSelectChip
                      label={"شماره شبا "}
                      value={valueIbans}
                      onChange={changeValueIbans}
                      changeMultiSelect={changeValueIbans}
                      name='ibans'
                      id='ibans'
                      options={ibansOption}
                    />
                  </div>
                  <div
                    className='col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12'
                    style={{ paddingTop: "30px" }}
                  >
                    <MultiSelectChip
                      label={"وضعیت "}
                      value={valueSaleStatuses}
                      onChange={changeValueSaleStatuses}
                      changeMultiSelect={changeValueSaleStatuses}
                      name='saleStatuses'
                      id='saleStatuses'
                      options={saleStatusesOption}
                    />
                  </div>
                  <div
                    className='col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12'
                    style={{ paddingTop: "30px" }}
                  >
                    <FormControl fullWidth className='shadowDatepicker'>
                      <DatePickerComponents
                        valueArray={settlementDate}
                        label={"تاریخ تسویه"}
                        onChange={changeValueSettlementDate}
                        range={true}
                      />
                    </FormControl>
                  </div>
                  <div
                    className='col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12'
                    style={{ paddingTop: "30px" }}
                  >
                    <FormControl fullWidth className='shadowDatepicker'>
                      <DatePickerComponents
                        valueArray={saleDate}
                        label={"تاریخ فروش"}
                        onChange={changeValueSaleDate}
                        range={true}
                      />
                    </FormControl>
                  </div>

                  <div
                    className='col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12 butFilter'
                    style={{ paddingTop: "30px" }}
                  >
                    <Button
                      fullWidth
                      variant='contained'
                      type='submit'
                      className='btnForm SuccessDefault  '
                    >
                      اعمال فیلتر
                    </Button>
                  </div>
                </div>

                {valueCustomerName ||
                valueCustomerNationalCode ||
                valueCustomerMobileNumber ||
                valueBranchIds?.length ||
                valueIbans?.length ||
                valueSaleStatuses?.length ||
                valueSettlementDate ||
                valueSaleDate ? (
                  <div className='row tableCMP'>
                    <Grid container xs={12}>
                      <Grid item xs={12} sm={0.5} style={{ marginTop: "20px" }}>
                        <Button
                          onClick={deleteChip}
                          style={{
                            justifyContent: "right",
                            minWidth: "25px",
                            marginRight: "-1vh",
                          }}
                        >
                          <img
                            style={{ height: "24px", width: "24px" }}
                            src='images/RemoveAllFilters.svg'
                          />
                        </Button>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        sm={11.5}
                        style={{ marginTop: "10px" }}
                      >
                        <ChipCmp
                          item={valueCustomerName}
                          enamValue={valueCustomerName}
                          index={valueCustomerName?.length}
                          setChildValue={setChildValueCustomerName}
                        />
                        <ChipCmp
                          item={valueCustomerNationalCode}
                          enamValue={valueCustomerNationalCode}
                          index={valueCustomerNationalCode?.length}
                          setChildValue={setChildValueCustomerNationalCode}
                        />
                        <ChipCmp
                          item={valueCustomerMobileNumber}
                          enamValue={valueCustomerMobileNumber}
                          index={valueCustomerMobileNumber?.length}
                          setChildValue={setChildValueCustomerMobileNumber}
                        />
                        <ChipCmp
                          item={valueBranchIds}
                          enamValue={branchOption}
                          index={valueBranchIds?.length}
                          setChildValue={setChildValueBranchIds}
                        />
                        <ChipCmp
                          item={valueIbans}
                          enamValue={ibansOption}
                          index={valueIbans?.length}
                          setChildValue={setChildValueIbans}
                        />
                        <ChipCmp
                          item={valueSaleStatuses}
                          enamValue={saleStatusesOption}
                          index={valueSaleStatuses?.length}
                          setChildValue={setChildValueSaleStatuses}
                        />
                        <ChipCmp
                          item={valueSettlementDate}
                          enamValue={valueSettlementDate}
                          index={valueSettlementDate?.length}
                          setChildValue={setChildValueSettlementDate}
                        />
                        <ChipCmp
                          item={valueSaleDate}
                          enamValue={valueSaleDate}
                          index={valueSaleDate?.length}
                          setChildValue={setChildValueSaleDate}
                        />
                      </Grid>
                    </Grid>
                  </div>
                ) : (
                  ""
                )}
              </form>
            )}
          </Formik>
        </Box>
      ) : (
        ""
      )}
      <br />
      <div>
        <TableContainer
          style={{ background: "#fff", direction: "rtl" }}
          className={`${data.length > 0 ? "scroll" : ""}`}
        >
          <Table
            stickyHeader
            aria-label='sticky table '
            style={{ borderCollapse: "collapse" }}
          >
            <TableHead className='rowTHead' style={{ paddingBottom: "10px" }}>
              <TableRow
                classes={{ root: classes.select }}
                className={`${classes} borderRight borderLeft`}
              >
                <TableCell
                  className='rowTHead colorTitle textFont12 fontWeight'
                  align='right'
                  style={{ width: "5px" }}
                >
                  ردیف
                </TableCell>
                {columns?.map((column) => (
                  <TableCell
                    className='rowTHead colorTitle textFont12 fontWeight nowrapClass'
                    key={column.id}
                    align='right'
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <div style={{ width: "100%", height: "10px" }}></div>

            <TableBody
              style={{
                height: "30px",
                minHeight: "30px",
              }}
            >
              {data?.map((row, rowIndex) => {
                return (
                  <TableRow
                    classes={{ root: classes.select }}
                    className={`${
                      rowIndex % 2 == 0
                        ? "rowTBodyE  borderRight borderLeft"
                        : "rowTBodyO  borderRight borderLeft"
                    }${classes} borderRight borderLeft cursorPointer noWrap`}
                    hover
                    role='checkbox'
                    tabIndex={-1}
                    // key={row.loanRequestId}
                    // selected={selectedRow === rowIndex}
                    onClick={() =>
                      handelDetail(
                        row.saleKey,
                        row.ibanNumber,
                        row.branchId,
                        row.ibanId,
                        rowIndex
                      )
                    }
                  >
                    <TableCell className='textFont12' style={{ width: "5px" }}>
                      {((currentPaginationInfo.pageNumber ?? 0) - 1) *
                        (currentPaginationInfo.pageSize! ?? 0) +
                        rowIndex +
                        1}
                    </TableCell>
                    {columns?.map((column) => {
                      const value = row[column.id as keyof IgroupedByBranches];
                      return (
                        <TableCell
                          className='textFont12 nowrapClass'
                          key={column.id}
                          align='right'
                        >
                          {column.format && column.hasFormat
                            ? column.format(value)
                            : value}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
        <div>
          <div className='row'></div>
          <Grid container xs={12}>
            <Grid item xs={4}>
              <span
                style={{ color: "#1D4A87", top: "1vh", position: "relative" }}
              >
                تعداد کل :
                <span style={{ color: "#01AF43" }}>{pageInfo?.total}</span> مورد
              </span>
            </Grid>
            <Grid item xs={4}>
              <Pagination
                renderItem={(item) => (
                  <PaginationItem
                    components={{
                      previous: previusIcon,
                      next: nextIcon,
                    }}
                    {...item}
                  />
                )}
                // color="primary"
                sx={{
                  display: "flex",
                  justifyContent: "center !important",
                  direction: "ltr",
                  margin: "5px",
                  button: {
                    color: "#25D1C9",
                    fontSize: "14px !important",
                    fontFamily: "iranSans",
                  },
                  //  button.sele
                }}
                count={Math.ceil(pageInfo?.total / pageInfo?.pageSize)}
                onChange={handleChangePagination}
                page={currentPaginationInfo.pageNumber}
              />
            </Grid>
            <Grid item xs={4}></Grid>
          </Grid>
        </div>
      </div>
    </>
  );
}
